import script from "./OTPInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OTPInput.vue?vue&type=script&setup=true&lang=js"

import "./OTPInput.vue?vue&type=style&index=0&id=42756fc7&lang=css"

const __exports__ = script;

export default __exports__